import { API } from 'services';

export function getGlobalContractParams() {
  return API({
    endpoint: '/global-contract-params',
  });
}

export function updateGlobalContractParams(params) {
  return API({
    method: 'PUT',
    endpoint: '/global-contract-params',
    ...params,
  });
}

